import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import { GraduationCap, ArrowRight } from "lucide-react";

// SPA soft-404. Marks noindex; hosting/edge layer must return HTTP 404 for real bots.
export default function NotFound() {
  return (
    <>
      <SEOHead
        title="Page not found"
        description="The page you're looking for doesn't exist on CollegeUnlock."
        noindex
      />
      <div data-testid="not-found-page" className="max-w-2xl mx-auto px-4 py-24 text-center">
        <GraduationCap className="mx-auto h-12 w-12 text-[#0B2A6B]" />
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold text-slate-900">Page not found</h1>
        <p className="mt-3 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2 rounded-lg bg-[#0B2A6B] px-5 py-3 text-sm font-bold text-white">Back to Home <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/pricing" className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700">See Pricing</Link>
        </div>
        <p className="mt-6 text-xs text-slate-400">Note: search engines are instructed not to index this page.</p>
      </div>
    </>
  );
}
